var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMediaIconBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 12.25V18.25L15 15.25L9.75 12.25Z",
    fill: "#06097D",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 22H4.5C4.1023 21.9996 3.721 21.8414 3.43978 21.5602C3.15856 21.279 3.0004 20.8977 3 20.5V10C3.0004 9.6023 3.15856 9.221 3.43978 8.93978C3.721 8.65856 4.1023 8.5004 4.5 8.5H19.5C19.8977 8.5004 20.279 8.65856 20.5602 8.93978C20.8414 9.221 20.9996 9.6023 21 10V20.5C20.9996 20.8977 20.8414 21.279 20.5602 21.5602C20.279 21.8414 19.8977 21.9996 19.5 22ZM4.5 10V20.5H19.5V10H4.5ZM4.5 5.5H19.5V7H4.5V5.5ZM6 2.5H18V4H6V2.5Z",
    fill: "#06097D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIconBlue);
export default __webpack_public_path__ + "static/media/media-icon-blue.41fbe9fa6ca1ae76913c8f0c6e240cfb.svg";
export { ForwardRef as ReactComponent };